import { render } from "./GroupNodeTree.vue?vue&type=template&id=b3e79bd0"
import script from "./GroupNodeTree.vue?vue&type=script&lang=js"
export * from "./GroupNodeTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__